import "react-app-polyfill/stable";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import configureStore from "./stores/configureStore";
import ReactGA from "react-ga";
import App from "./App";
import "./less/style.less";

const store = configureStore();
const reactGaCode = process.env.REACT_APP_GA;

ReactGA.initialize(reactGaCode ?? "");

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
